/// <reference path="../interfaces/lightsliderconfig.ts" />
module Tapas.ViewModels {
    export class ProductPageViewModel extends Tapas.ViewModels.CartViewModel {

        public favoriteVisible: KnockoutObservable<boolean>;
        public tabToggle: KnockoutObservable<number>;
        public lightSliderConfig: LightSliderConfig;
        public lightSliderGalleryConfig: LightSliderConfig; 
        public lightSlider: JQuery; //TODO Make interface to lightSlider

        constructor() {

            super();            

            this.lightSlider = $();
            this.favoriteVisible = ko.observable(false);
            this.tabToggle = ko.observable(1);

            this.lightSliderGalleryConfig = {
                gallery: true,
                item: 1,
                loop: false,
                thumbItem: 5,
                thumbMargin: 20,
                slideMargin: 0,
                enableDrag: false,
                slideEndAnimation: false,
                onSliderLoad: function (el) {
                    el.lightGallery({ 
                    })
                }
            }        
        }

        //TOGGLE SPEC TABS
        public tabOne() {
            this.tabToggle(1);
        }
        //TOGGLE SPEC TABS
        public tabTwo() {
            this.tabToggle(2);
        }
    }
}